import React from 'react';
import * as PropTypes from 'prop-types';
import JsxParser from 'react-jsx-parser';
import Markdown from 'react-markdown';

import EmbeddedLink, { isEmbeddableLink } from './EmbeddedLink';
import { makeBackendUrl } from './../../lib/backend';

const Heading = ({ color, depth = 1, children, align = 'center' }) => {
  if (depth > 6 && depth <= 0) {
    depth = 6;
  }
  const HeadingTag = 'h' + depth;
  return <HeadingTag style={{ color, textAlign: align }}>{children}</HeadingTag>;
};
const Paragraph = ({ color, align = 'center', children }) => {
  return <p style={{ color, textAlign: align }}>{children}</p>;
};

const Span = ({ color, underline, children }) => (
  <span style={{ textDecoration: underline && 'underline', color }}>{children}</span>
);
const Section = ({ id }) => <span style={{ display: 'block' }} id={id} />;

const componentTransforms = {
  // Custom component wrapper should wrap our custom components
  CC: props => <>{props.children}</>, // <CC><MyCustomComponent/></CC>
  // Components => Usage
  Heading, // <CC><Heading color="red" depth="1" align="left">text</Heading></CC>
  Paragraph, // <CC><Paragraph color="red" align="left">text</Paragraph></CC>
  Span, // <CC><Span color="red" underline="true">text</Span></CC>
  Section, //<CC><Section id="first-section" /></CC>
};

const ReactMarkdown = ({ source }) => {
  return (
    <Markdown
      source={source}
      transformImageUri={uri => {
        if (/^https?:/.test(uri)) {
          return uri;
        }

        return makeBackendUrl(uri);
      }}
      renderers={{
        link: props => {
          // only render when href attribute and link value are the same
          const renderCondition =
            React.Children.count(props.children) === 1 &&
            props.children[0].props.value === props.href;

          if (isEmbeddableLink(props.href) && renderCondition) {
            return <EmbeddedLink href={props.href} />;
          }

          return (
            <a
              href={props.href}
              target={
                props.href && props.href.indexOf('#') !== -1
                  ? '_self'
                  : props.href.indexOf('http') === 0
                  ? '_blank'
                  : '_self'
              }
            >
              {props.children}
            </a>
          );
        },
        html: props => <JsxParser jsx={props.value} components={componentTransforms} />,
      }}
    />
  );
};

ReactMarkdown.propTypes = {
  source: PropTypes.string,
};

export default ReactMarkdown;
